import { BMButtonGroup, BMCard } from "@traveloka/district-bloom";
import { useState } from "react";
import { StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import {
  MobileHomeNextTripProps,
  NextTripTabsType,
} from "./MobileHomeNextTrip";
import NextTripContent from "./NextTripContent";

export default function NextTripTabs(props: MobileHomeNextTripProps) {
  const initialValue = "FLIGHT";
  const [selectedTab, setSelectedTab] =
    useState<NextTripTabsType>(initialValue);

  const { CorporatePostLogin: cr } = useMobileContentResource();

  const items = [
    {
      label: cr.flightTab,
      value: "FLIGHT",
    },
    {
      label: cr.hotelTab,
      value: "HOTEL",
    },
  ];

  function handleTabChange(value: (string | number)[]) {
    if (!value[0]) return;
    setSelectedTab(value[0] as NextTripTabsType);
  }

  return (
    <BMView spacing="md">
      <BMView>
        <BMButtonGroup
          items={items}
          onChange={handleTabChange}
          initialValues={[initialValue]}
          multipleValue={false}
          singleRow
        />
      </BMView>
      <BMCard style={styles.card} layout="COMPACT" elevation="FLOAT">
        <NextTripContent {...props} selectedTab={selectedTab} />
      </BMCard>
    </BMView>
  );
}

const styles = StyleSheet.create({
  card: {
    height: 90,
  },
});
